import dayjs from 'dayjs';
import { createElement, memo, useContext, useState, useEffect, useMemo, useRef } from '@max/max';
import { presendCoupon, sendCoupon, getVerifyUrl } from './api/request';
import { CouponStatus, TYPE_MAP, FLASH_TYPE_MAP, TSS_MAP, arrIconUrl } from './constants';
import { allQueryInWeb } from './utils/common-utils';
import { navigateTo } from '@max/meituan-uni-navigate';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@max/leez-image';
import ImageBackground from '@hfe/max-imagebackground';
import ScrollView from '@hfe/max-scrollview';
import './index.scss';
import LinearGradient from '@hfe/max-linear-gradient';
import Coupon from './components/coupon';
import { TechStackUtil, KNB } from '@nibfe/mkt-common-utils';
import { useMonitorNavigation } from '@nibfe/mcp-monitor-sdk';
import { getPlatformType, PlatformType, isMeituanAppOrWebview, isWeixinMiniProgramOrWeixinWebview } from '@nibfe/mkt-env-api';
import { useThrottle } from './hooks/useThrottle';
import RuleModel from './components/RuleModal';
import CouponUsageRecord from './components/coupon-usage-record';
const isWeb = true;
const isMRN = false;
import Sensor from '@max/mbc-sensor';
import msi from './utils/msi/index';
const SceneToken = 'dj-1f72542c5947e11a';
const MyComponent = (props) => {
    // 从全局变量global取Context
    const ctx = useContext(global._EngineGlobalContext);
    const commonParams = ctx._runtimeInfo?.commonParams ?? {};
    const { couponType, flashConfig, earlyConfig, headerConfig, jumpConfig, toastConfig, reminderConfig, calendarConfig } = props;
    const { modalTitle, modalTitleColor, activityRulePicture, firstTitle, firstContent, secondTitle, secondContent, thirdTitle, thirdContent } = headerConfig.modalConfig;
    const couponInfoAllList = useRef([]);
    const [couponInfoList, setCouponInfoList] = useState([]);
    const [timePeriodList, setTimePeriodList] = useState([]);
    const [amount, setAmount] = useState(0);
    const [visible, setVisible] = useState(TechStackUtil.isInEditor()); //默认不展示，编辑页默认展示
    const [first, setFirst] = useState(true); // 是否第一次领取
    const [modalVisible, setModalVisible] = useState(false);
    const [timePeriodId, setTimePeriodId] = useState(''); // 默认选择的时段
    const [timePeriodIndex, setTimePeriodIndex] = useState(0);
    const [isShowCouponUsageRecord, setIsShowCouponUsageRecord] = useState(false); //领券记录弹窗控制
    const [reminderOpenData, setReminderOpenData] = useState({}); // 提醒开关 ， 设置提醒后，下次再进入依旧未未设置提醒（当前能力无法判断是否设置日程）
    const [activityIdList, setActivityIdList] = useState([]);
    const scrollViewRef = useRef(null);
    const timerRef = useRef(null);
    const isStandardKNB = /KNB\//i.test(navigator.userAgent) && /MSI\//i.test(navigator.userAgent);
    const { monitorNavigateTo } = useMonitorNavigation();
    // 根据couponType选择不同的配置
    const couponConfig = useMemo(() => {
        return couponType === 'flash' ? flashConfig : earlyConfig;
    }, [couponType]);
    useEffect(() => {
        if (couponType === 'flash') {
            setActivityIdList([couponConfig?.activityId, couponConfig?.earlyActivityId]);
        }
        initData();
        ctx._LXReport?.mvReport('b_daodian_lowcode_ltzudt57_mv', {
            valLab: {
                type: 0
            }
        });
    }, []);
    const initData = async () => {
        try {
            const data = await presendCoupon({
                activityId: couponConfig?.activityId,
                scene: 1
            }, commonParams);
            setAmount(Math.floor(Number(data?.moduleInfoList[0]?.rewardModuleInfoVO?.rewardAmount || 0) / 100));
            if (couponType === 'flash') {
                // 命中所有的券的风控，接口返回空
                if (data?.moduleInfoList[0]?.rewardModuleInfoVO?.userPrizeInfos.length === 0) {
                    setVisible(false);
                    return;
                }
                // 这里使用接口返回的字段判断是否第一次领取
                // 已领奖展示领取后的券，未领奖展示当前时间所处时段的券
                if (data?.moduleInfoList[0]?.rewardModuleInfoVO?.isDrawReward) {
                    setVisible(true);
                    // 已领奖 接口返回的券肯定是领过的，前段无需过滤
                    setFirst(false);
                    couponInfoAllList.current = data?.moduleInfoList[0]?.rewardModuleInfoVO?.userPrizeInfos;
                    // 排序 无库存、已过期、已使用后置
                    couponInfoAllList.current.sort((a, b) => {
                        // 检查是否需要置后的数据
                        const shouldDelayA = a.prizeStatus === 2 && a.cannotDrawCode === 120001 || a.prizeStatus === 4 || a.prizeStatus === 5;
                        const shouldDelayB = b.prizeStatus === 2 && b.cannotDrawCode === 120001 || b.prizeStatus === 4 || b.prizeStatus === 5;
                        if (shouldDelayA && !shouldDelayB)
                            return 1;
                        if (shouldDelayB && !shouldDelayA)
                            return -1;
                        return 0;
                    });
                    setCouponInfoList(couponInfoAllList.current);
                }
                else {
                    // 领取前。所有券都没库存，本场已抢光， 不可以根据无库存就隐藏组件
                    // 检查所有的券是否都不可领取，如果都不可领取，则不展示组件.
                    let userPrizeInfos = data?.moduleInfoList[0]?.rewardModuleInfoVO?.userPrizeInfos;
                    let drawTimeSlotList = data?.moduleInfoList[0]?.rewardModuleInfoVO?.drawConfigInfo?.drawTimeSlotList;
                    let allEmpty = userPrizeInfos?.every((userPrizeInfoItem) => userPrizeInfoItem.prizeStatus === 2 && userPrizeInfoItem.cannotDrawCode === 120001 && drawTimeSlotList?.every((timeSlotItem) => userPrizeInfoItem.showStatus[timeSlotItem.timeSlotId] !== 1));
                    // console.log('allEmpty', allEmpty)
                    if (allEmpty) {
                        setVisible(!allEmpty);
                        return;
                    }
                    setVisible(true);
                    couponInfoAllList.current = data?.moduleInfoList[0]?.rewardModuleInfoVO?.userPrizeInfos;
                    // console.log('data-----', data);
                    // console.log('couponType-----', couponType);
                    // console.log('isDrawReward-----', data?.moduleInfoList[0]?.rewardModuleInfoVO?.isDrawReward);
                    setFirst(true);
                    // 未领奖
                    // 设置时段list，设置激活的时段，设置激活时段的券
                    const currentTimestamp = dayjs().valueOf();
                    let defultTimePeriodId = '';
                    let idx = 0;
                    let defultCouponInfoList = [];
                    const timeSlotList = data?.moduleInfoList[0]?.rewardModuleInfoVO?.drawConfigInfo.drawTimeSlotList.map((item, index) => {
                        const startTimestamp = dayjs(dayjs().format('YYYY-MM-DD') + ' ' + `${item.startTime.slice(0, 2)}:${item.startTime.slice(2, 4)}:${item.startTime.slice(4, 6)}`).valueOf(); // 开始时间只有时分秒，自己拼年月日
                        const endTimestamp = dayjs(dayjs().format('YYYY-MM-DD') + ' ' + `${item.endTime.slice(0, 2)}:${item.endTime.slice(2, 4)}:${item.endTime.slice(4, 6)}`).valueOf(); // 结束时间只有时分秒，自己拼年月日
                        // 过滤掉showStatus为2的券，并增加一个字段showStatusCurrent表达当前时段的券的展示状态
                        let temporaryCouponInfoList = couponInfoAllList.current.filter((coupon) => coupon.showStatus[item.timeSlotId] === 1 || coupon.showStatus[item.timeSlotId] === 3).map((coupon) => ({
                            ...coupon,
                            showStatusCurrent: coupon.showStatus[item.timeSlotId]
                        }));
                        // 排序 无库存3 后置,有可能出现状态全为3的情况（时段库存空了），则使用第二优先级排序
                        temporaryCouponInfoList.sort((a, b) => {
                            // 第一优先级：showStatusCurrent === 3 放后面
                            if (a.showStatusCurrent === 3 && b.showStatusCurrent !== 3)
                                return 1;
                            if (b.showStatusCurrent === 3 && a.showStatusCurrent !== 3)
                                return -1;
                            // 第二优先级：prizeStatus === 2 && cannotDrawCode === 120001  || prizeStatus === 4 || prizeStatus === 5放后面
                            const aIsDelayed = a.prizeStatus === 2 && a.cannotDrawCode === 120001 || a.prizeStatus === 4 || a.prizeStatus === 5;
                            const bIsDelayed = b.prizeStatus === 2 && b.cannotDrawCode === 120001 || b.prizeStatus === 4 || b.prizeStatus === 5;
                            if (aIsDelayed && !bIsDelayed)
                                return 1;
                            if (bIsDelayed && !aIsDelayed)
                                return -1;
                            return 0;
                        });
                        //1、实际时间小于场次结束时间即设置场次激活项，设置后不再重新赋值
                        if (currentTimestamp < endTimestamp && defultTimePeriodId === '' && defultCouponInfoList.length === 0) {
                            defultTimePeriodId = item.timeSlotId;
                            defultCouponInfoList = temporaryCouponInfoList;
                            idx = index;
                        }
                        //2、兜底，存在所有场次都已过期的情景，将最后一个场次设置为激活项，领券按钮置灰，文字展示“场次已过期”，并且无法切换场次
                        if (index === data?.moduleInfoList[0]?.rewardModuleInfoVO?.drawConfigInfo.drawTimeSlotList.length - 1 && defultTimePeriodId === '' && defultCouponInfoList.length === 0) {
                            defultTimePeriodId = item.timeSlotId;
                            defultCouponInfoList = temporaryCouponInfoList;
                            idx = index;
                        }
                        // 处理时段状态 1未开抢/2已开抢/3已过期
                        let timeSlotSatus = 1;
                        if (currentTimestamp < startTimestamp) {
                            timeSlotSatus = 1;
                        }
                        else if (currentTimestamp >= startTimestamp && currentTimestamp < endTimestamp) {
                            timeSlotSatus = 2;
                        }
                        else if (currentTimestamp >= endTimestamp) {
                            timeSlotSatus = 3;
                        }
                        return {
                            ...item,
                            userPrizeInfos: temporaryCouponInfoList,
                            timeSlotSatus
                        };
                    });
                    // console.log('defultTimePeriodId------', defultTimePeriodId);
                    // console.log('defultCouponInfoList---', defultCouponInfoList);
                    setTimePeriodId(defultTimePeriodId);
                    setTimePeriodIndex(idx);
                    setCouponInfoList(defultCouponInfoList);
                    setTimePeriodList(timeSlotList);
                }
            }
            else if (couponType === 'early') {
                // 提前定，保持之前的逻辑
                couponInfoAllList.current = data?.moduleInfoList[0]?.rewardModuleInfoVO?.userPrizeInfos?.filter(item => item.prizeStatus !== CouponStatus.InVaild) || [];
                setVisible(couponInfoAllList.current.length > 0);
                if (couponInfoAllList.current.length === 0)
                    return;
                // 这里有个隐藏逻辑，如果用户已经领取过券，并且全部用完了，会恢复成未领取的状态
                // 这里使用接口返回的券的状态判断是否第一次领取
                setFirst(couponInfoAllList.current.every((item) => [CouponStatus.NotClaimed, CouponStatus.InVaild].includes(item.prizeStatus)));
                setCouponInfoList(couponInfoAllList.current);
            }
        }
        catch (e) {
            // if (e.status === 507) {
            //   ctx._uiInteractionAPI.toast.show({
            //     content: '请稍后重试',
            //   });
            // }
            setCouponInfoList([]);
            setAmount(0);
            setVisible(TechStackUtil.isInEditor());
            setFirst(true);
        }
    };
    const handleCouponClick = useThrottle(async (couponData) => {
        // 首次进入无法点击单张券，
        if (first)
            return;
        // 无库存的券无法点击,但是需要埋点
        if (couponData.prizeStatus === CouponStatus.InVaild && couponData.cannotDrawCode === 120001) {
            ctx._LXReport?.mcReport('b_daodian_lowcode_t5w1n49c_mc', {
                valLab: {
                    type: 10
                }
            });
            return;
        }
        else {
            ctx._LXReport?.mcReport('b_daodian_lowcode_t5w1n49c_mc', {
                valLab: {
                    type: couponType == 'flash' ? FLASH_TYPE_MAP[couponData.prizeStatus] : TYPE_MAP[couponData.prizeStatus]
                }
            });
        }
        if (couponData.prizeStatus !== CouponStatus.NotClaimed) {
            const urlObj = new URL(couponData.jumpUrl || jumpConfig[couponData.bizLine]);
            const MTH5Url = 'https://w.dianping.com/cube/evoke/meituan.html?url=';
            if (isWeixinMiniProgramOrWeixinWebview()) {
                // let miniProgramUrl = `${encodeURIComponent(MTH5Url + encodeURIComponent(urlObj.toString()))}`;
                let miniProgramUrl = `${encodeURIComponent(urlObj.toString())}`;
                const platformType = getPlatformType();
                switch (platformType) {
                    case PlatformType.mtMinaWebview:
                        // 美团小程序
                        monitorNavigateTo({
                            url: `/index/pages/h5/pt/h5?weburl=${miniProgramUrl}`,
                            _web: {
                                miniProgramNative: true
                            }
                        });
                        break;
                    case PlatformType.mtHotelMinaWebview:
                        // 美团酒店小程序
                        monitorNavigateTo({
                            url: `/pages/h5/index?q=${miniProgramUrl}`,
                            _web: {
                                miniProgramNative: true
                            }
                        });
                        break;
                    case PlatformType.dpMinaWebview:
                        // 点评小程序
                        monitorNavigateTo({
                            url: `/pages/webview/webview?url=${miniProgramUrl}`,
                            _web: {
                                miniProgramNative: true
                            }
                        });
                        break;
                    default:
                        monitorNavigateTo({
                            url: `/index/pages/h5/pt/h5?weburl=${miniProgramUrl}`
                        });
                        break;
                }
            }
            else {
                const evokeMtAappUrl = isMeituanAppOrWebview() || isMRN ? urlObj.toString() : `${MTH5Url}${encodeURIComponent(urlObj.toString())}`;
                navigateTo({
                    url: evokeMtAappUrl.replace(/\/$/, '') || '',
                    _web: {
                        miniProgramNative: true
                    }
                });
            }
            return;
        }
        try {
            const result = await sendCoupon({
                activityId: couponConfig.activityId,
                activityName: couponConfig.activityId,
                drawParam: {
                    prizeBatchId2TypeMap: {
                        [couponData.prizeBatchId]: couponData.amountType
                    },
                    moduleType: 6,
                    drawExtraInfo: {
                        scene: 1
                    }
                }
            }, commonParams);
            if (result?.userPrizeInfos && Array.isArray(result.userPrizeInfos)) {
                const updatedList = couponInfoList.map((item) => {
                    const updatedCoupon = result.userPrizeInfos.find((newItem) => newItem.prizeBatchId === item.prizeBatchId);
                    if (updatedCoupon) {
                        return {
                            ...item,
                            prizeStatus: updatedCoupon.prizeStatus,
                            expireTime: updatedCoupon.expireTime,
                            cannotDrawCode: updatedCoupon.cannotDrawCode
                        };
                    }
                    return item;
                });
                setCouponInfoList(updatedList);
                setFirst(false);
            }
            ctx._uiInteractionAPI.toast.show({
                content: toastConfig.successTip
            });
        }
        catch (e) {
            // if (e?.status === 507) {
            //   ctx._uiInteractionAPI.toast.show({
            //     content: '请稍后重试',
            //   });
            // }
            if (e?.status === 120002) {
                // 需要实名认证
                setTimeout(() => {
                    goToVerifyIdentify();
                }, 1000);
                ctx._uiInteractionAPI.toast.show({
                    content: '未实名认证，1s后跳转至实名认证界面'
                });
            }
            else {
                ctx._uiInteractionAPI.toast.show({
                    content: toastConfig.otherFailTip
                });
            }
            initData();
        }
    }, 300, () => {
        ctx._uiInteractionAPI.toast.show({
            content: toastConfig.tooFastTip
        });
    });
    const handleBatchCouponClick = useThrottle(async (couponDatas, timePeriod) => {
        let temporaryCouponInfoList = [];
        if (couponType === 'flash') {
            //秒杀领券的入参，list 带上无库存的券list
            const timeSlotId = timePeriod?.timeSlotId;
            if (!timeSlotId)
                return;
            temporaryCouponInfoList = couponInfoAllList.current.filter((coupon) => coupon.showStatus[timeSlotId] === 1 || coupon.showStatus[timeSlotId] === 3);
            // 秒杀时，前端判断场次和领取时间是否一致，弹窗告诉用户“场次已过期”，前端重新初始化组件
            const currentTimestamp = dayjs().valueOf();
            const startTimestamp = dayjs(dayjs().format('YYYY-MM-DD') + ' ' + `${timePeriod?.startTime.slice(0, 2)}:${timePeriod?.startTime.slice(2, 4)}:${timePeriod?.startTime.slice(4, 6)}`).valueOf(); // 开始时间只有时分秒，自己拼年月日
            const endTimestamp = dayjs(dayjs().format('YYYY-MM-DD') + ' ' + `${timePeriod?.endTime.slice(0, 2)}:${timePeriod?.endTime.slice(2, 4)}:${timePeriod?.endTime.slice(4, 6)}`).valueOf(); // 结束时间只有时分秒，自己拼年月日
            if (currentTimestamp < startTimestamp || currentTimestamp > endTimestamp) {
                ctx._uiInteractionAPI.toast.show({
                    content: '当前时间不在该场次内'
                });
                initData();
                return;
            }
        }
        else if (couponType === 'early') {
            // 提前订保持之前的入参券list
            temporaryCouponInfoList = couponDatas;
        }
        ctx._LXReport?.mcReport('b_daodian_lowcode_t5w1n49c_mc', {
            valLab: {
                type: couponType === 'flash' ? 12 : 0 // 秒杀一键领取 12，提前订一键领取 0
            }
        });
        // if (temporaryCouponInfoList.some(item => item.cannotDrawCode === CannotCode.Verify)) {
        //   setTimeout(() => {
        //     goToVerifyIdentify();
        //   }, 1000);
        //   ctx._uiInteractionAPI.toast.show({
        //     content: '未实名认证，1s后跳转至实名认证界面',
        //   });
        //   return;
        // }
        const prizeBatchId2TypeMap = {};
        temporaryCouponInfoList.forEach(item => {
            prizeBatchId2TypeMap[item.prizeBatchId] = item.amountType;
        });
        try {
            const result = await sendCoupon({
                activityId: couponConfig.activityId,
                activityName: couponConfig.activityId,
                drawParam: {
                    prizeBatchId2TypeMap,
                    moduleType: 6,
                    drawExtraInfo: {
                        scene: 1
                    }
                }
            }, commonParams);
            // console.log('result-----', result);
            if (result?.userPrizeInfos && Array.isArray(result.userPrizeInfos)) {
                const updatedList = couponInfoList.map((item) => {
                    const updatedCoupon = result.userPrizeInfos.find((newItem) => newItem.prizeBatchId === item.prizeBatchId);
                    if (updatedCoupon) {
                        return {
                            ...item,
                            prizeStatus: updatedCoupon.prizeStatus,
                            expireTime: updatedCoupon.expireTime,
                            cannotDrawCode: updatedCoupon.cannotDrawCode
                        };
                    }
                    return item;
                });
                // console.log('updatedList-----', updatedList);
                setCouponInfoList(updatedList);
                setFirst(false);
                // 过滤掉不可领取数据，更新下领奖金额
                let rewardAmount = updatedList.filter((item) => item.prizeStatus !== CouponStatus.InVaild)?.reduce((total, item) => {
                    if (item.amountType === 2) {
                        return total + Number(item.maxDiscountAmount);
                    }
                    else {
                        return total + Number(item.amount);
                    }
                }, 0);
                setAmount(Math.floor(Number(rewardAmount || 0) / 100));
            }
            ctx._uiInteractionAPI.toast.show({
                content: toastConfig.successTip
            });
        }
        catch (e) {
            // if (e.status === 507) {
            //   ctx._uiInteractionAPI.toast.show({
            //     content: '请稍后重试',
            //   });
            // }
            if (e?.status === 120002) {
                // 需要实名认证
                setTimeout(() => {
                    goToVerifyIdentify();
                }, 1000);
                ctx._uiInteractionAPI.toast.show({
                    content: '未实名认证，1s后跳转至实名认证界面'
                });
            }
            else if (e?.status === 10062) {
                // 库存不足
                ctx._uiInteractionAPI.toast.show({
                    content: toastConfig.emptyTip
                });
            }
            else {
                ctx._uiInteractionAPI.toast.show({
                    content: toastConfig.otherFailTip
                });
            }
            initData();
        }
    }, 300, () => {
        ctx._uiInteractionAPI.toast.show({
            content: toastConfig.tooFastTip
        });
    });
    const onVerifyFail = () => {
        ctx._uiInteractionAPI.toast.show({
            content: '如果您已实名，请重进页面试试哦~'
        });
    };
    const goToVerifyIdentify = async () => {
        if (isMeituanAppOrWebview()) {
            getVerifyUrl(commonParams).then(res => {
                const { link, requestId } = res || {};
                navigateTo({
                    // 测试地址可以mock实名成功
                    // url: 'http://test02.awp.hfe.test.meituan.com/ffe/verified-sdk/set-result-test.html '
                    url: link
                }).then(value => {
                    if (value?.resultData && value?.resultData !== '{}') {
                        try {
                            const data = JSON.parse(value.resultData);
                            const { requestId: id, status } = data || {};
                            if (String(id) === String(requestId) && status === 'success') {
                                setTimeout(() => {
                                    initData();
                                }, 1000);
                                ctx._uiInteractionAPI.toast.show({
                                    content: '1s后为您自动刷新，请稍后~'
                                });
                            }
                            else {
                                onVerifyFail();
                            }
                        }
                        catch (error) {
                            onVerifyFail();
                            ctx._raptorReport.reportLog('实名认证跳转失败', JSON.stringify({
                                url: link
                            }), {
                                category: 'stagePrizeException',
                                level: 'info'
                            });
                        }
                    }
                    else {
                        onVerifyFail();
                    }
                });
            }).catch(e => {
                ctx._uiInteractionAPI.toast.show({
                    content: '跳转失败，请到美团APP中操作实名认证~'
                });
            });
        }
        else {
            ctx._raptorReport.reportLog('实名认证', JSON.stringify({
                platform: allQueryInWeb().programName
            }), {
                level: 'info',
                category: 'stagePrizeException',
                tags: {
                    name: '引导用户去美团实名'
                }
            });
            ctx._uiInteractionAPI.toast.show({
                content: '请到美团APP中操作实名认证~'
            });
        }
    };
    // 切换时段
    const handleTimePeriodClick = (timePeriod, idx) => {
        if (timePeriod.timeSlotSatus === 3) {
            ctx._uiInteractionAPI.toast.show({
                content: '场次已过期～'
            });
            return;
        }
        ctx._LXReport?.mcReport('b_daodian_lowcode_t5w1n49c_mc', {
            valLab: {
                type: 11
            }
        });
        setTimePeriodId(timePeriod.timeSlotId);
        setTimePeriodIndex(idx);
        setCouponInfoList(timePeriod.userPrizeInfos);
    };
    //时段条数据超过三项时的默认宽度
    const timePeriodItemBoxWidth = 192; // 232
    // 初始化时段条时，默认滚动
    const scrollTo = () => {
        if (timePeriodList.length > 3) {
            let scrollIndex = timePeriodList.findIndex((item) => timePeriodId === item.timeSlotId);
            scrollX = scrollIndex * timePeriodItemBoxWidth;
            // scrollX = 232
            scrollViewRef?.current?.scrollTo?.({
                x: scrollX / 2,
                animated: true,
                duration: 1000
            });
        }
    };
    //  初始化设置提醒
    useEffect(() => {
        let temporaryData = {};
        timePeriodList.map((timePeriod) => {
            temporaryData[timePeriod.timeSlotId] = false;
        });
        setReminderOpenData(temporaryData);
    }, [timePeriodList]);
    // 根据下一个未开抢的场次初始化一个定时器（如果不存在则不用处理），时间到了就执行initData()，并销毁倒计时
    useEffect(() => {
        if (timePeriodList.length === 0 || !first || couponType !== 'flash')
            return;
        const currentTimestamp = dayjs().valueOf();
        let notStartTimePeriodIndex = timePeriodList.findIndex((item) => {
            const startTimestamp = dayjs(dayjs().format('YYYY-MM-DD') + ' ' + `${item.startTime.slice(0, 2)}:${item.startTime.slice(2, 4)}:${item.startTime.slice(4, 6)}`).valueOf(); // 开始时间只有时分秒，自己拼年月日
            return currentTimestamp < startTimestamp;
        });
        if (notStartTimePeriodIndex !== -1) {
            const nextTimePeriod = timePeriodList[notStartTimePeriodIndex];
            const startTimestamp = dayjs(dayjs().format('YYYY-MM-DD') + ' ' + `${nextTimePeriod.startTime.slice(0, 2)}:${nextTimePeriod.startTime.slice(2, 4)}:${nextTimePeriod.startTime.slice(4, 6)}`).valueOf();
            const delayTime = startTimestamp - currentTimestamp;
            timerRef.current = setTimeout(() => {
                initData();
            }, delayTime);
        }
        return () => {
            if (timerRef.current)
                clearTimeout(timerRef.current);
            timerRef.current = undefined;
        };
    }, [timePeriodList]);
    const onHandleReminderSwitchChange = (timePeriod) => {
        // 只能订阅不能取消
        if (!reminderOpenData[timePeriod.timeSlotId]) {
            const subscribeParams = {
                title: calendarConfig.calendarTitle || '秒杀提醒',
                // 日历标题
                url: calendarConfig.targetUrl ? calendarConfig.targetUrl + (calendarConfig.targetUrl.includes('?') ? '&' : '?') + 'from=calendar' : '',
                // 日历目标页面
                alarm: true,
                success: function (success) {
                    console.log('success', success);
                    // 5：秒杀组件-开抢提醒 点击埋点-成功
                    ctx._LXReport?.mcReport('b_daodian_lowcode_t5w1n49c_mc', {
                        valLab: {
                            type: 5
                        }
                    });
                    ctx._uiInteractionAPI.toast.show({
                        content: '设置提醒成功'
                    });
                    let temporaryData = {
                        ...reminderOpenData
                    };
                    temporaryData[timePeriod.timeSlotId] = true;
                    setReminderOpenData(temporaryData);
                },
                fail: function (error) {
                    console.log('fail', error);
                    ctx._uiInteractionAPI.toast.show({
                        content: '设置提醒失败，请稍后再试'
                    });
                }
            };
            if (isWeb && !isStandardKNB) {
                subscribeParams.sceneToken = SceneToken;
                subscribeParams.start = dayjs(dayjs().format('YYYY-MM-DD') + ' ' + timePeriod.startTime).valueOf(),
                    // Number 类型, 开始时间， 毫秒时间戳
                    subscribeParams.duration = 3600, subscribeParams.notes = calendarConfig.calendarDesc || '',
                    // 日历说明
                    KNB?.setupEvent?.(subscribeParams);
            }
            else {
                subscribeParams._mt = {
                    sceneToken: SceneToken
                }, subscribeParams.startTime = dayjs(dayjs().format('YYYY-MM-DD') + ' ' + timePeriod.startTime).unix(),
                    // Number 类型, 开始时间， 毫秒时间戳,
                    subscribeParams.endTime = dayjs(dayjs().format('YYYY-MM-DD') + ' ' + timePeriod.startTime).unix() + 3600,
                    // Number 类型, 开始时间， 毫秒时间戳,
                    subscribeParams.alarmOffset = 0, subscribeParams.switchToCalendar = true,
                    // 是否调用系统日历，false，表示直接添加日历
                    msi?.addPhoneCalendar?.(subscribeParams);
            }
        }
    };
    // 渲染秒杀未领券时的底部区域
    const flashRenderFirstBottom = useMemo(() => {
        // 状态整理  timeSlotSatus 1未开抢/2已开抢/3已过期
        // 未开抢 && 未提醒，按钮文字为：开抢提醒，按钮颜色使用默认的渐变色
        // 未开抢 && 已提醒，按钮文字为：已开抢提醒 ，按钮颜色使用禁用的渐变色
        // 进行中 && 未抢光，按钮文字为：（已有逻辑）文字和按钮颜色已完备
        // 进行中 && 已抢光，按钮文字为：本场已抢光，按钮颜色使用禁用的渐变色
        // 已过期，         根据当前时间和场次结束时间判断，结束后的场次无法点击
        const isAllEmpty = couponInfoList.every((item) => item.showStatusCurrent !== 1);
        const timePeriod = timePeriodList.find((item) => item.timeSlotId === timePeriodId);
        const timeSlotSatus = timePeriod?.timeSlotSatus;
        const btnText = couponInfoList.length === 1 ? couponConfig?.earlyBtnTextOne : couponConfig?.earlyBtnTextMore;
        const parts = btnText?.split('$');
        return first && <View className="allBtnContainer" style={couponInfoList.length === 1 ? {
                top: 0,
                right: 0,
                height: '188rpx'
            } : {
                bottom: 0,
                width: '702rpx'
            }}>
        <ImageBackground className="allBtnBg" source={{
                uri: couponInfoList.length === 1 ? couponConfig?.coverImageOne : couponConfig?.coverImageMore
            }} resizeMode={'cover'} style={{
                width: couponInfoList.length === 1 ? '284rpx' : '702rpx',
                height: couponInfoList.length === 1 ? '188rpx' : '129rpx'
            }}>
          {/* LinearGradient-colors：按钮渐变色，当券类型为秒杀时，要判断按钮是否禁用样式（已开抢提醒or本场已抢光） */}
          <LinearGradient className="allBtn" start={{
                x: 0.2,
                y: 1
            }} end={{
                x: 0.8,
                y: 0
            }} colors={isAllEmpty && timeSlotSatus > 1 || reminderOpenData[timePeriod?.timeSlotId] ? [couponConfig?.btnStartDisabledColor, couponConfig?.btnEndDisabledColor] : [couponConfig?.btnStartColor, couponConfig?.btnEndColor]} style={couponInfoList.length === 1 ? {
                width: '228rpx',
                height: '60rpx',
                borderRadius: '32rpx',
                marginBottom: '64rpx',
                marginLeft: '12rpx'
            } : {
                width: '400rpx',
                height: '80rpx',
                borderRadius: '460rpx',
                marginBottom: '12rpx'
            }}>
            {/* todo 预约提醒点击创建日程的逻辑 */}
            {/*  未开抢 && 未提醒  */}
            <View x-if={timeSlotSatus === 1 && !reminderOpenData[timePeriod?.timeSlotId]} className="allBtnContent" style={{
                color: couponConfig?.btnTextColor,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
            }} onClick={() => onHandleReminderSwitchChange(timePeriod)}>
              <Text className="allBtnText" style={{
                color: couponConfig?.btnTextColor
            }}>{reminderConfig?.remindText}</Text>
            </View>
            {/*  未开抢 && 已提醒  */}
            <View x-if={timeSlotSatus === 1 && reminderOpenData[timePeriod?.timeSlotId]} className="allBtnContent" style={{
                color: couponConfig?.btnTextDisabledColor,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
              <Text className="allBtnText" style={{
                color: couponConfig?.btnTextDisabledColor
            }}>{reminderConfig?.remindedText}</Text>
            </View>
            {/*  进行中 未抢光 */}
            <View x-if={timeSlotSatus === 2 && !isAllEmpty} className="allBtnContent" style={{
                color: couponConfig?.btnTextColor,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
            }} onClick={() => handleBatchCouponClick(couponInfoList, timePeriod)}>
              <>
                <Text className="allBtnText" style={{
                color: couponConfig?.btnTextColor
            }}>{parts && parts[0]}</Text>
                {amount > 0 && parts.length > 1 && <>
                    <Text className="allBtnTextNum" style={{
                    color: couponConfig?.btnTextColor
                }}>
                      {amount}
                    </Text>
                    <Text className="allBtnText" style={{
                    color: couponConfig?.btnTextColor
                }}>元</Text>
                  </>}
                <Text className="allBtnText" style={{
                color: couponConfig?.btnTextColor
            }}>{parts && parts[1]}</Text>
              </>
            </View>
            {/* （已开抢 已抢光） */}
            <View x-if={timeSlotSatus === 2 && isAllEmpty} className="allBtnContent" style={{
                color: couponConfig?.btnTextDisabledColor,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
              <Text className="allBtnText" style={{
                color: couponConfig?.btnTextDisabledColor
            }}>本场已抢光</Text>
            </View>
            {/* 已过期的场次（timeSlotSatus === 3）点击不切换，这里也无需渲染dom */}
            <View x-if={timeSlotSatus === 3} className="allBtnContent" style={{
                color: couponConfig?.btnTextDisabledColor,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
              <Text className="allBtnText" style={{
                color: couponConfig?.btnTextDisabledColor
            }}>场次已过期</Text>
            </View>
          </LinearGradient>
        </ImageBackground>
      </View>;
    }, [couponType, first, couponConfig, timePeriodId, timePeriodList, couponInfoList, reminderOpenData, amount]);
    // 渲染提前订未领券时的底部区域
    const earlyRenderFirstBottom = useMemo(() => {
        const btnText = couponInfoList.length === 1 ? couponConfig?.earlyBtnTextOne : couponConfig?.earlyBtnTextMore;
        const parts = btnText?.split('$');
        return first && <View className="allBtnContainer" style={couponInfoList.length === 1 ? {
                top: 0,
                right: 0,
                height: '188rpx'
            } : {
                bottom: 0,
                width: '702rpx'
            }} onClick={() => handleBatchCouponClick(couponInfoList)}>
        <ImageBackground className="allBtnBg" source={{
                uri: couponInfoList.length === 1 ? couponConfig?.coverImageOne : couponConfig?.coverImageMore
            }} resizeMode={'cover'} style={{
                width: couponInfoList.length === 1 ? '284rpx' : '702rpx',
                height: couponInfoList.length === 1 ? '188rpx' : '129rpx'
            }}>
          <LinearGradient className="allBtn" start={{
                x: 0.2,
                y: 1
            }} end={{
                x: 0.8,
                y: 0
            }} colors={[couponConfig?.btnStartColor, couponConfig?.btnEndColor]} style={couponInfoList.length === 1 ? {
                width: '228rpx',
                height: '60rpx',
                borderRadius: '32rpx',
                marginBottom: '64rpx',
                marginLeft: '12rpx'
            } : {
                width: '400rpx',
                height: '80rpx',
                borderRadius: '460rpx',
                marginBottom: '12rpx'
            }}>
            <View className="allBtnContent" style={{
                color: couponConfig?.btnTextColor,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
              <>
                <Text className="allBtnText" style={{
                color: couponConfig?.btnTextColor
            }}>{parts && parts[0]}</Text>
                {amount > 0 && parts.length > 1 && <>
                    <Text className="allBtnTextNum" style={{
                    color: couponConfig?.btnTextColor
                }}>
                      {amount}
                    </Text>
                    <Text className="allBtnText" style={{
                    color: couponConfig?.btnTextColor
                }}>元</Text>
                  </>}
                <Text className="allBtnText" style={{
                color: couponConfig?.btnTextColor
            }}>{parts && parts[1]}</Text>
              </>
            </View>
          </LinearGradient>
        </ImageBackground>
      </View>;
    }, [couponType, first, couponConfig, couponInfoList]);
    // {/* 时段顶部: 有时段 && 判断是否领取过 */}
    const timePeriodScrollViewBox = useMemo(() => {
        return <View x-if={couponType === 'flash' && first} className="timePeriodBar" style={{
                height: '76rpx',
                backgroundColor: couponConfig?.timePeriodBgColor
            }}>

      {/* 时段 未领取时的滚动条  */}
      <Sensor onAppear={() => scrollTo()} once={true}>
        <ScrollView bounces={false} alwaysBounceVertical={false} ref={scrollViewRef} className="timePeriodScrollView" horizontal={true} showsHorizontalScrollIndicator={false} disableScroll={timePeriodList.length <= 3}>
          {timePeriodList.map((item, idx) => <View key={idx} className='timePeriodItemBox' onClick={() => handleTimePeriodClick(item, idx)} style={{
                    width: timePeriodList.length <= 3 ? `${702 / timePeriodList.length}rpx` : TSS_MAP[item.timeSlotSatus].length >= 4 ? '206rpx' : timePeriodItemBoxWidth + 'rpx',
                    backgroundColor: timePeriodId === item.timeSlotId ? couponConfig?.timePeriodSelectedBgColor : 'transparent',
                    borderBottomLeftRadius: timePeriodId === item.timeSlotId && idx === 0 ? '0rpx' : '24rpx',
                    borderBottomRightRadius: timePeriodId === item.timeSlotId && idx == timePeriodList.length - 1 ? '0rpx' : '24rpx'
                }}>
                <View x-if={timePeriodId === item.timeSlotId} className="timePeriodItemBeforeAfter" style={{
                    zIndex: timePeriodId === item.timeSlotId ? 3 : 1
                }}>
                  {/* 激活项的左侧  非第一项才展示内部“1/4圆”  */}
                  <View x-if={timePeriodId === item.timeSlotId && idx > 0} className="timePeriodItemSplicingBoxLeft" style={{
                    backgroundColor: couponConfig?.timePeriodSelectedBgColor,
                    width: '56rpx',
                    borderTopLeftRadius: isMRN ? '48rpx' : '0rpx'
                }}>
                    <View className="cutttingCircle1" style={{
                    backgroundColor: couponConfig?.timePeriodBgColor
                }}></View>
                  </View>
                  {/* 激活项的右侧 非最后一项才展示内部“1/4圆” */}
                  <View x-if={timePeriodId === item.timeSlotId && idx < timePeriodList.length - 1} className="timePeriodItemSplicingBoxRight" style={{
                    backgroundColor: couponConfig?.timePeriodSelectedBgColor
                }}>
                    <View className="cutttingCircle2" style={{
                    backgroundColor: couponConfig?.timePeriodBgColor
                }}></View>
                  </View>
                  {/* 两个补充圆装饰 */}
                  <View x-if={timePeriodId === item.timeSlotId && idx > 0} className="replenishCircle1" style={{
                    backgroundColor: couponConfig?.timePeriodSelectedBgColor
                }}></View>
                  <View x-if={timePeriodId === item.timeSlotId && idx < timePeriodList.length - 1} className="replenishCircle2" style={{
                    backgroundColor: couponConfig?.timePeriodSelectedBgColor
                }}></View>
                </View>
                {/*  宽度判断，背景色判断，z-index判断，圆角判断  */}
                <View className="timePeriodItemContainer" style={{
                    backgroundColor: timePeriodId === item.timeSlotId ? 'transparent' : couponConfig?.timePeriodBgColor
                }}>
                  <Text className="timePeriodItemContainerTime" style={{
                    color: timePeriodId === item.timeSlotId ? couponConfig?.timePeriodSelectedColor : couponConfig?.timePeriodColor
                }}>{item.startTime.slice(0, 2)}:{item.startTime.slice(2, 4)}</Text>
                  <Text className="timePeriodItemContainerTips" style={{
                    color: timePeriodId === item.timeSlotId ? couponConfig?.timePeriodSelectedTextColor : couponConfig?.timePeriodTextColor
                }}>{TSS_MAP[item.timeSlotSatus]}</Text>
                </View>
                <View x-if={idx > timePeriodIndex + 1} className="timePeriodItemIntervalMask1" style={{
                    backgroundColor: couponConfig?.timePeriodBgColor
                }}>
                </View>
                <View x-if={idx > timePeriodIndex + 1} className="timePeriodItemIntervalMask2" style={{
                    backgroundColor: couponConfig?.timePeriodBgColor
                }}>
                </View>
              </View>)}
        </ScrollView>
      </Sensor>
    </View>;
    }, [timePeriodId, timePeriodList, timePeriodIndex]);
    if (!visible)
        return <></>;
    return <View>
      <View className="headImgContainer" onClick={() => setModalVisible(true)}>
        <Image source={{
            uri: couponType === 'early' ? headerConfig.headerImage : headerConfig.headerImageFlash
        }} resizeMode="cover">
        </Image>
      </View>
      <View className="couponContainer">
        {/* 时段顶部: 有时段 && 判断是否领取过 */}
        {first && couponType === 'flash' ? timePeriodScrollViewBox : null}
        <ImageBackground className="couponBg" source={{
            uri: first ? couponConfig?.notClaimedImage : couponConfig?.claimedImage
        }} resizeMode={'cover'} style={{
            width: '702rpx',
            height: couponInfoList.length === 1 ? `${188 + (couponType === 'flash' && !first ? 58 : 0)}rpx` : `${278 + (couponType === 'flash' && !first ? 58 : 0)}rpx`,
            top: couponType === 'flash' && first ? '-18rpx' : '0rpx'
        }}>
          {/* 秒杀  已领取 */}
          <View x-if={couponType === 'flash' && !first} className="timePeriodClaimedHeader">
            <View className="timePeriodClaimedHeaderLeft">
              <Text className="timePeriodClaimedHeaderLeftText">已领取 <Text className="timePeriodClaimedHeaderLeftTextNum">{amount}</Text>{` 元${couponConfig?.claimedText}`}</Text>
            </View>
            <View className="timePeriodClaimedHeaderRight" onClick={() => setIsShowCouponUsageRecord(true)}>
              <Text className="timePeriodClaimedHeaderRightText">领券记录</Text>
              {/* <Icon name='right-line-regular' type='label1' color='#555' className='demo-icon-icon' iconFontType='meishi' /> */}
              <Image source={{
            uri: arrIconUrl
        }} style={{
            width: '20rpx',
            height: '20rpx'
        }}></Image>
            </View>
          </View>
          <View x-if={couponInfoList.length <= 3} className="couponItemContainer">
            {couponInfoList.map((data, idx) => <Coupon key={idx} width={`${(666 - 12 * (couponInfoList.length - 1)) / couponInfoList.length}rpx`} height={couponInfoList.length === 1 ? '152rpx' : '242rpx'} isSingle={couponInfoList.length === 1} couponData={data} singleCouponShowTag={couponConfig?.singleCouponShowTag} onClick={() => handleCouponClick(data)}/>)}
          </View>
          <ScrollView x-else horizontal={true} showsHorizontalScrollIndicator={false}>
            <View className='couponItemContainer'>
              {couponInfoList.map((data, idx) => <Coupon key={idx} width={`202rpx`} height={'242rpx'} isSingle={false} couponData={data} onClick={() => handleCouponClick(data)}/>)}
            </View>
          </ScrollView>
          {couponType === 'flash' ? flashRenderFirstBottom : earlyRenderFirstBottom}
        </ImageBackground>
      </View>
      <CouponUsageRecord modalVisible={isShowCouponUsageRecord} activityIdList={activityIdList} jumpConfig={jumpConfig} toastConfig={toastConfig} commonParams={commonParams} onCloseModal={() => {
            setIsShowCouponUsageRecord(false);
        }}/>
      <RuleModel visible={modalVisible && headerConfig.showRule} modalTitle={modalTitle} modalTitleColor={modalTitleColor} activityRulePicture={activityRulePicture} firstTitle={firstTitle} firstContent={firstContent} secondTitle={secondTitle} secondContent={secondContent} thirdTitle={thirdTitle} thirdContent={thirdContent} onClose={() => setModalVisible(false)}/>
    </View>;
};
export default memo(MyComponent);
